import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ForgotFormValues, RootState } from "../../../../@types";
import { useFormik } from "formik";
import logo from "../../assets/images/logo 2 (1).svg";
import { Box, Button, Flex, Image, Input, Label, Spinner, Text } from "theme-ui";
import theme from "../../../theme";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ActionCreateByUrl } from "../../../store/actions/CommonAction";

const validationSchema = Yup.object({
    email: Yup.string().email('Invalid Email format').required('Email is required'),
});

const ClientEmailVerify = () => {
    const navigate = useNavigate();
    const loader = useSelector((state: RootState) => state.auth.loader);
    const dispatch = useDispatch();
    const Formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: validationSchema,
        onSubmit: (values: ForgotFormValues,) => {

            dispatch(ActionCreateByUrl({ Query: "/otp/otp-generate", obj: values }, (res: any) => {
                if (res.status) {
                    navigate('/verify-otp', { state: { email: values.email, otp: res?.data?.data.otp } });
                }
                else {
                    // Handle failure
                    console.error('Error sending OTP:', res.data);
                }
            }))

        },

    });
    const { handleSubmit, values, errors, handleBlur, handleChange } = Formik;

    return (
        <>
            <Flex
                sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '90vh' }}>
                <Image src={logo} alt="Logo" sx={{ width: ["70%", "30%", "20%"], height: 'auto' }} />
                <Box sx={{ width: ['90%', '70%', '40%'], mt: 6, gap: "23px" }}>
                    <form onSubmit={handleSubmit}>
                        <Box mb={3}>
                            <Label htmlFor="email" style={{ fontSize: "17px", fontWeight: '600' }}>Email</Label>
                            <Input type="Email" id="email" name="email" className='form-control' onChange={handleChange} onBlur={handleBlur} value={values.email} placeholder="Enter your Email"
                                sx={{
                                    width: '100%', p: 2, mt: 1, border: '1px solid', borderColor: Formik.touched.email && Formik.errors.email ? `${theme?.colors?.red}` : 'red',
                                }} />
                            {Formik.touched.email && Formik.errors.email && (
                                <Text sx={{ color: `${theme?.colors?.red}`, mt: 1 }}> {Formik.errors.email} </Text>
                            )}
                        </Box>
                        <Button type="submit" sx={{ width: '100%', bg: `${theme.colors?.primary}`, color: `${theme?.colors?.white}`, py: 2, borderRadius: '4px', cursor: 'pointer' }}>
                            {loader ? (<Spinner sx={{ color: theme.colors?.background, width: 3, p: 0, m: 0 }} />) : ("Send OTP")}
                        </Button>
                    </form>
                </Box>
            </Flex>
        </>
    )
}

export default ClientEmailVerify